import { string, bool, oneOfType, object } from 'prop-types';

import { useLocation } from 'react-router';
import Anchor from 'components/base/Anchor/Anchor';

export default Link;

/**
 * Link is a Anchor component specific to the OverviewContainer
 * @param {bool} props.isHeadline Bool that defines if the link is the headline
 * @param {string} props.to String or Object that gets passed on as "to" attribute of the Anchor element
 * @param {string} props.isAnchor Bool that defines if the element is an anchor (links to something on the same page)
 * @param {string} props.title Block title
 */
function Link(props) {
  const { isHeadline, title, to, isAnchor } = props;

  const location = useLocation();
  const withChevron = !isHeadline && !isAnchor;
  const handleOnClick = () => {
    // Scroll to the top when we navigate to the topic
    // so the users know where they went.
    if (!isAnchor) {
      window.scrollTo({
        top: 0,
        behavior: 'instant',
      });
    }
  };

  return (
    <Anchor
      to={to}
      withChevron={withChevron}
      location={location}
      onClick={handleOnClick}
    >
      {!isHeadline && (isAnchor ? 'Jump to ' : 'Go to ')} {title}
    </Anchor>
  );
}

Link.propTypes = {
  isHeadline: bool,
  to: oneOfType([string, object]).isRequired,
  isAnchor: bool,
  title: string.isRequired,
};
